import React from 'react';
import PropTypes from 'prop-types';
import { APP_ENV } from 'appenv';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import EventLogo from 'assets/event-logo.png';
import PolyULogo from 'assets/polyu-logo.png';
import SPEEDLogo from 'assets/speed-logo.png';
import DesktopAppBar from './DesktopAppBar';
import MobileAppBar from './MobileAppBar';

export default function XtraAppBar({ hideSearchBar, hideUser }) {
  const isDesktop = useMediaQuery('(min-width: 960px)');

  const logoUrlList = React.useMemo(() => {
    switch (APP_ENV) {
      case 'polyu618_staging': case 'polyu618_production':
        return [PolyULogo, SPEEDLogo];
      default: return [EventLogo];
    }
  }, []);

  return isDesktop ? (
    <DesktopAppBar
      hideSearchBar={hideSearchBar}
      hideUser={hideUser}
      logos={logoUrlList}
    />
  ) : (
    <MobileAppBar logos={logoUrlList} />
  );
}

XtraAppBar.propTypes = {
  hideSearchBar: PropTypes.bool,
  hideUser: PropTypes.bool,
};

XtraAppBar.defaultProps = {
  hideSearchBar: false,
  hideUser: false,
};
